<template>
  <div class="h-full relative">
    <!--    <VideoFavorite-->
    <!--      v-if="userIsAuthenticated && !video.available"-->
    <!--      :video="video"-->
    <!--    />-->
    <div class="h-full flex flex-col" @click="showRegister">
      <VideoImage :video="video" />

      <div
        class="text-left pt-4 pb-8 px-4 flex-grow flex flex-col justify-between"
      >
        <div>
          <h4 class="text-xl">
            <strong>{{ video.title }}</strong>
          </h4>

          <VideoViewing
            v-if="userIsAuthenticated && video.viewing_percentage"
            :video="video"
          />

          <VideoTags :video="video" />
        </div>

        <VideoSchedule :video="video" />
      </div>
    </div>

    <VideoAuthModal v-if="showVideoAuthModal" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import VideoImage from '@/components/VideoListItemContentImage'
import VideoViewing from '@/components/VideoListItemContentViewing'
import VideoTags from '@/components/VideoListItemContentTags'
import VideoSchedule from '@/components/VideoListItemContentSchedule'
// import VideoFavorite from '@/components/VideoListItemContentFavorite'
import VideoAuthModal from '@/components/VideoAuthModal'

export default {
  components: {
    VideoImage,
    VideoViewing,
    VideoTags,
    VideoSchedule,
    // VideoFavorite,
    VideoAuthModal,
  },

  props: {
    video: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState('videos', ['showVideoAuthModal']),
    ...mapGetters('auth', ['userIsAuthenticated']),
  },

  methods: {
    showRegister() {
      if (!this.userIsAuthenticated) {
        this.$store.commit('videos/setShowVideoAuthModal', true)
      }
    },
  },
}
</script>
